<div class="xbrldata">
  <div class="content-container pt-3">
    <div>
      <h1 class="h-1 mt-0" tabindex="0">{{xbrldataHeader}}</h1>
    </div>
    <div class="details">{{xbrldetails}}</div>
    <div class="test">
      <div class="flex-display justify-content-flex-end width-100">
        <button mat-button class="download-button" (click)="downloadData()" (keyup.enter)="downloadData()" tabindex="0">
          {{xbrlbutton}}
        </button>
        <button mat-button class="export-button" (click)="downloadondemandData()" (keyup.enter)="downloadondemandData()" tabindex="0">
          {{xbrlonbutton}}
        </button>
      </div>
    </div>

    <div class="justify-content-flex-end">
      <div style="overflow:scroll;">
        <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" aria-label="Users" class="mt-3rem tablea" aria-describedby="xbrl datatable">
          <ng-container matColumnDef="areaTitle">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem">{{AreaTitle}}</th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='areaTitle'?'#F0F5FF':null" class="width-10rem"> {{element.areaTitle}} </td>
          </ng-container>

          <ng-container matColumnDef="topic">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem">{{Topic}}</th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='topic'?'#F0F5FF':null" class="width-10rem"> {{element.topic}} </td>
          </ng-container>
          <ng-container matColumnDef="subTopic">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{SubTopic}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='subTopic'?'#F0F5FF':null" class="width-10rem"> {{element.subTopic}} </td>
          </ng-container>
          <ng-container matColumnDef="section">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{Section}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='section'?'#F0F5FF':null" class="width-10rem"> {{element.section}} </td>
          </ng-container>
          <ng-container matColumnDef="paragraph">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{Paragraph}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='paragraph'?'#F0F5FF':null" class="width-10rem"> {{element.paragraph}} </td>
          </ng-container>
          <ng-container matColumnDef="subParagraph">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem">{{SubParagraph}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='subParagraph'?'#F0F5FF':null" class="width-10rem"> {{element.subParagraph}} </td>
          </ng-container>
          <ng-container matColumnDef="elementName">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem">{{ElementName}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='elementName'?'#F0F5FF':null" class="width-10rem"> {{element.elementName}} </td>
          </ng-container>
          <ng-container matColumnDef="title">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{Title}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='title'?'#F0F5FF':null" class="width-10rem"> {{element.title}} </td>
          </ng-container>
          <ng-container matColumnDef="elementID">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{ElementId}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='elementID'?'#F0F5FF':null" class="width-10rem"> {{element.elementID}} </td>
          </ng-container>
          <ng-container matColumnDef="refRole">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{RefRole}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='refRole'?'#F0F5FF':null" class="width-10rem"> {{element.refRole}} </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{Status}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='status'?'#F0F5FF':null" class="width-10rem"> {{element.status}} </td>
          </ng-container>
          <ng-container matColumnDef="lastUpdated">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header class="width-10rem"> {{LastUpdated}} </th>
            <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='lastUpdated'?'#F0F5FF':null" class="width-10rem"> {{element.lastUpdated|date:'yyyy-MM-dd'}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;let headerRow"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
      </div>

      <div>
        <mat-paginator [pageSize]="pagesize" [pageSizeOptions]="[10,25,50,75,100]" appHostListenerClick>
        </mat-paginator>
      </div>

    </div>
  </div>





